'use client';



import clsx from 'clsx';

import { Reveal, RevealItem, SectionHeading } from '@/components/ui';

import { fadeUp } from '@/lib/motion';

import { useAnimatedStat } from '@/hooks/useAnimatedStat';

import s from './IndustryResults.module.css';

import { useTranslation } from '@/hooks/useTranslation';



function StatCell({ value, label }) {
  const { ref, display } = useAnimatedStat(value);

  return (
    <article ref={ref} className={s.cell}>
      <span className={s.num}>{display}</span>
      <span className={s.lbl}>{label}</span>
    </article>
  );
}



/*

 * Results & Outcomes — full-width dark proof band + hairline-divided stat grid.

 */

export default function IndustryResults({

  eyebrow,

  headingTitle,

  headingAccent,

  heading,

  subtitle,

  stats,

}) {

  const { t } = useTranslation();

  if (!stats || stats.length === 0) return null;



  const useProofHeader = Boolean(headingTitle);



  return (

    <section className={`${s.section} ${s.section}`} id="results" aria-labelledby="results-heading">

      <div className={s.inner}>

        <Reveal variant={fadeUp} className={s.head}>

          {useProofHeader ? (

            <SectionHeading

              eyebrow={eyebrow ? t(eyebrow) : undefined}

              title={t(headingTitle)}

              titleAccent={headingAccent ? t(headingAccent) : undefined}

              accentBlock

              size="lg"

              align="center"

              headingId="results-heading"

              className={s.headingWrap}

              titleClassName={s.heading}

            />

          ) : (

            <>

              {eyebrow && <span className="lb-eyebrow">{t(eyebrow)}</span>}

              <h2 id="results-heading" className={clsx('type-section-title-lg', s.heading)}>

                {t(heading)}

              </h2>

              {subtitle && <p className={s.sub}>{t(subtitle)}</p>}

            </>

          )}

        </Reveal>



        <Reveal stagger={0.06} className={s.stats}>

          {stats.map((st, i) => (

            <RevealItem key={i} as="div" className={s.statItem}>

              <StatCell
                value={st.n}
                label={t(st.l)}
              />

            </RevealItem>

          ))}

        </Reveal>

      </div>

    </section>

  );

}


